module.exports = __webpack_public_path__ + "static/Tinext-MCS-815ce6ab3894959320ae96823bf8d741.jpg";